export default {
  /**
   * バリデーションエラー
   */
  VALIDATION_ERROR: 'VALIDATION_ERROR',

  /**
   * バリデーション以外の業務エラー（突合エラー等）
   */
  GLOBAL_ERROR: 'GLOBAL_ERROR',

  /**
   * その他サーバ側での予期せぬエラー
   */
  SERVER_ERROR: 'SERVER_ERROR',
} as const
